import type { ApiUser } from '#/api/userEnvironment/types/ApiUserEnvironment';
import type { AppConstants } from '#/config/appConstants';
import type { AppConfig } from '#/config/types/AppConfig';
import type {
  ClientEnvironment,
  IsomorphicEnvironment,
} from '#/contexts/UserEnvironmentContext';
import type { I18nLocale } from '#/i18n/types/I18nLocale';

type Props = {
  locale: I18nLocale;
  user: ApiUser | null;
  clientEnvironment: ClientEnvironment | null;
  isomorphicEnvironment: IsomorphicEnvironment;
  appConfig: AppConfig;
  appConstants: AppConstants;
};

export function HorizonSetIdealistObjectScript({
  locale,
  user,
  clientEnvironment,
  isomorphicEnvironment,
  appConfig,
  appConstants,
}: Props) {
  const idealistObject = {
    locale,
    initUserEnvironment: { user, clientEnvironment, isomorphicEnvironment },
    config: appConfig,
    appConstants,
  } satisfies typeof Idealist;

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: [
          `window.Idealist = ${JSON.stringify(idealistObject)};`,
          'window.dataLayer = window.dataLayer || [];',
        ].join(''),
      }}
    />
  );
}
